/**
 * aws1's news API: every news read, the app API, app updates, feeds, sitemaps,
 * media and the newsletter's links. heyday.news itself serves only the pages.
 */
export const API_ORIGIN = "https://api.heyday.news";
